export default __webpack_public_path__ + "static/media/bars.63c400f9.svg";